import servicesAPI from '@/api/resources/services'

const state = {
  all: []
}

const getters = {
  allServices: state => state.all,
  getServiceById: (state, getters) => (id) => {
    return state.all.find(service => service.id === id)
  }
}

const actions = {
  getAllServices ({ commit }) {
    return new Promise((resolve, reject) => {
      servicesAPI.loadAllServices().then(result => {
        commit('receiveServices', result)
        resolve()
      })
    })
  }
}

const mutations = {
  receiveServices (state, services) {
    state.all = services
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/services.js